<template>
  <section :class="sectionClass" v-if="item.modulaufforderungueberschrift">
    <div class="container">
      <h2 class="section-title demand__title">
        <span class="headline" v-html="item.modulaufforderungueberschrift"></span>
      </h2>
      <div class="row">
        <div class="column column-offset-10 column-80">
          <div class="demand__text" v-html="item.modulaufforderungtext"></div>
        </div>
      </div>
      <div class="center" v-if="item.modulaufforderungbutton.url">
        <a
          :href="item.modulaufforderungbutton.url"
          :target="item.modulaufforderungbutton.target"
          class="button button--cat1 button--large"
          v-html="item.modulaufforderungbutton.text"
        >
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModulAufforderung',
  data() {
    return {
      item: this.context.item,
    };
  },
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    sectionClass: function () {
      if (this.context.item.modulaufforderungstyle != '')
        return 'outer demand section-styling-' + this.context.item.modulaufforderungstyle;
      return 'outer demand section-styling-0';
    },
  },
};
</script>
